import React, { useEffect, useState, useCallback } from 'react';
import { Routes, Route, useLocation } from 'react-router-dom';
import { ajax } from './utils/request';
import { getToken, removeToken } from './utils/storage';

import Navbar from './components/Navbar';
import Home from './home/home';
import Work from './work';
import Subscribe from './pay/sub';
import About from './components/about';
import Contact from './components/contact';
import Documentation from './components/doc';
import Pricing from './components/pricing';
import MyAccount from './components/Myaccount';
import Faq from './components/faq';
import Login from './components/login';
import Register from './components/register';
import ResetPassword from './components/resetpassword';
import ChatPdf from './components/ChatPdf';
import CiviRender from './components/CiviRender';

const AppContent = () => {
  const [user, setUser] = useState(null);

  const [loginOpen, setLoginOpen] = useState(false);
  const [registerOpen, setRegisterOpen] = useState(false);
  const [faqOpen, setFaqOpen] = useState(false);
  const [pricingOpen, setPricingOpen] = useState(false);
  const [myAccountOpen, setMyAccountOpen] = useState(false);

  const location = useLocation();
  const hideNavbar = location.pathname.startsWith('/c/') || location.pathname.startsWith('/pdf/') || location.pathname.startsWith('/render/');

  const fetchMe = useCallback(async () => {
    try {
      const token = await getToken();
      if (!token) {
        setUser(null);
        return;
      }
      const res = await ajax.get('/user/me');
      const data = res?.data?.data;
      if (data) {
        setUser({ name: data.username, email: data.email });
      } else {
          await removeToken();
          setUser(null);
      }
    } catch (err) {
      console.error("Erreur récupération utilisateur après register:", err);
      await removeToken();
      setUser(null);
    }
  }, []);

  useEffect(() => {
    fetchMe();
  }, [fetchMe]);

  const handleLogout = async () => {
    await removeToken();
    setUser(null);
  };

  return (
    <>
      {!hideNavbar && (
        <Navbar
          user={user}
          setLoginOpen={setLoginOpen}
          setRegisterOpen={setRegisterOpen}
          setFaqOpen={setFaqOpen}
          setPricingOpen={setPricingOpen}
          setMyAccountOpen={setMyAccountOpen}
          handleLogout={handleLogout}
        />
      )}

      {/* Modals */}
      <Pricing isOpen={pricingOpen} setOpen={setPricingOpen} />
      <MyAccount
        isOpen={myAccountOpen}
        setOpen={setMyAccountOpen}
        onLogoutSuccess={async () => {
          await handleLogout();
          setMyAccountOpen(false);
        }}
      />
      <Login
        isOpen={loginOpen}
        setOpen={setLoginOpen}
        setRegisterOpen={setRegisterOpen}
        onLoginSuccess={async () => { 
            await fetchMe(); 
          }}
      />
      <Register
        isOpen={registerOpen}
        setOpen={setRegisterOpen}
        setLoginOpen={setLoginOpen}
        onRegisterSuccess={async () => {
            await fetchMe();
          }}
      />
      <Faq isOpen={faqOpen} setOpen={setFaqOpen} />

      {/* Routes */}
      <Routes>
        <Route path="/" element={
            <Home 
              isLoggedIn={!!user}
              setLoginOpen={setLoginOpen}
              setRegisterOpen={setRegisterOpen}
              setAccountOpen={setMyAccountOpen}
              setPricingOpen={setPricingOpen}
              setFaqOpen={setFaqOpen}
              />
            } />
        <Route path="/about" element={
            <About 
              isLoggedIn={!!user}
              setLoginOpen={setLoginOpen}
              setAccountOpen={setMyAccountOpen}
              setPricingOpen={setPricingOpen}
              setFaqOpen={setFaqOpen}
              />
            } />
        <Route path="/contact" element={
            <Contact 
              isLoggedIn={!!user}
              setLoginOpen={setLoginOpen}
              setAccountOpen={setMyAccountOpen}
              setPricingOpen={setPricingOpen}
              setFaqOpen={setFaqOpen}
              />
            } />
        <Route path="/documentation" element={
            <Documentation 
              isLoggedIn={!!user}
              setLoginOpen={setLoginOpen}
              setAccountOpen={setMyAccountOpen}
              setFaqOpen={setFaqOpen}
              />
            } />
        <Route path="/c/start" element={<Work />} />
        <Route path="/c/:chatId" element={<Work />} />
        <Route path="/book" element={
          <Subscribe
            isLoggedIn={!!user}
            setLoginOpen={setLoginOpen}
            setAccountOpen={setMyAccountOpen}
            setPricingOpen={setPricingOpen}
            setFaqOpen={setFaqOpen}
            />
          } />
        <Route path="/pdf/start" element={<ChatPdf />} />
        <Route path="/pdf/:chatId" element={<ChatPdf />} />
        <Route path="/reset-password" element={<ResetPassword />} />
        <Route path="/render/start" element={<CiviRender />} />
        <Route path="/render/:chatId" element={<CiviRender />} />
      </Routes>
    </>
  );
};

export default AppContent;